import React, {Component} from 'react';
import PatientInfo from './PatientInfo';
import UserProfile from './UserProfile';


export default class NewPatient extends Component {

    state = {
        data : {}
    }

	componentDidMount() {
        this.setState({data : {
            user : {
                media_id : '',
                firstname : 'Click to add new photo',
                lastname : '',
            },
            id: ''
        }})
	}

    handleSavePatientInfo = (e) => {
        e.persist();
    };

	render() {

		let params = this.props.params; // from router

		return (
			<div className="page-content">
                <div className="row">
                    <div className="col-md-12" style={{minHeight : '167px'}}>
                        <UserProfile data={this.state.data} onMediaChoice={this.handleSavePatientInfo} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="profile-content">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="portlet light">
                                        <div className="portlet-body">
                                            <PatientInfo storeParams={params} patientData={this.state.data} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
		)
	}

}


/** WEBPACK FOOTER **
 ** ./src/components/patient/NewPatient.js
 **/